import React, { FC, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'
import AuthenticationContext from '../Authentication/AppContext'
import LoginService from '../service/LoginService'
import ErrorMessage, { closeErrorAlert } from '../utils/ErrorMessage'

export const PasswordChange: FC<{}> = () => {
  const { needsPasswordChange, refreshUserDetails } = React.useContext(AuthenticationContext)
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = React.useState(false)
  const [validated, setValidated] = useState(false)
  const [error, setError] = React.useState(null as any)
  const [showError, setShowError] = React.useState(false)
  const { t } = useTranslation()

  if (!needsPasswordChange) {
    return <Redirect to='/' />
  }

  function getData() {
    return {
      oldPassword,
      newPassword,
      confirmPassword,
    }
  }

  const handleSubmit = (event: any) => {
    const form = event.currentTarget
    event.preventDefault()
    if (form.checkValidity() === false) {
      event.stopPropagation()
    }
    LoginService.updatePassword(getData(), t, refreshUserDetails, setLoading).catch((err) => {
      setError(err.message)
      setShowError(true)
    })
    setValidated(true)
  }

  return (
    <>
      <Helmet>
        <title>Gateway [{t('login')}]</title>
      </Helmet>
      <Col md='8' className='p-5 mx-auto'>
        <Form noValidate validated={validated} className='form-passwordchnage' onSubmit={handleSubmit}>
          <h1 className='text-center'>{t('passwordUpdate.Header')}</h1>
          <Form.Group as={Row}>
            <Form.Label column sm={4} className='text-wrap text-break text-break-all'>
              {t('passwordUpdate.oldPassword')}
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                as='input'
                id='oldPassword'
                required={true}
                type='password'
                autoComplete='current-password'
                placeholder={t('passwordUpdate.oldPassword')}
                value={oldPassword}
                onChange={(e: any) => setOldPassword(e.target.value)}></Form.Control>

              <Form.Control.Feedback type='invalid'>{t('passwordUpdate.inValidMessage')}</Form.Control.Feedback>
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={4} className='text-wrap text-break text-break-all'>
              {t('passwordUpdate.newPassword')}
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                as='input'
                id='newPassword'
                required={true}
                type='password'
                autoComplete='new-password'
                placeholder={t('passwordUpdate.newPassword')}
                value={newPassword}
                onChange={(e: any) => setNewPassword(e.target.value)}></Form.Control>

              <Form.Control.Feedback type='invalid'>{t('passwordUpdate.inValidMessage')}</Form.Control.Feedback>
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={4} className='text-wrap text-break text-break-all'>
              {t('passwordUpdate.confirmPassword')}
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                as='input'
                id='confirmPassword'
                required={true}
                type='password'
                autoComplete='new-password'
                placeholder={t('passwordUpdate.confirmPassword')}
                value={confirmPassword}
                onChange={(e: any) => setConfirmPassword(e.target.value)}></Form.Control>

              <Form.Control.Feedback type='invalid'>{t('passwordUpdate.inValidMessage')}</Form.Control.Feedback>
            </Col>
          </Form.Group>

          <Row>
            <Col>
              <Button type='submit' disabled={loading} block={true}>
                {loading ? (
                  <>
                    <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' />
                    <span className='ml-1'>{t('loading')}</span>
                  </>
                ) : (
                  t('passwordUpdate.updatePassword')
                )}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <ErrorMessage error={error} show={showError} onClose={closeErrorAlert(setError, setShowError)} />
            </Col>
          </Row>
        </Form>
      </Col>
    </>
  )
}
